/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IOutputOrderSettingsModalControllerScope extends IBaseModalControllerScope {
        model: models.OutputOrderModel;
        validationMessages: string[];
        save() : void;
    }

    export class OutputOrderSettingsModalController extends BaseModalController {
        scope: IOutputOrderSettingsModalControllerScope;

        constructor(
            $scope: IOutputOrderSettingsModalControllerScope,
            model: models.OutputOrderModel,
            workflowService: services.WorkflowService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.model = model;
            this.scope.save = () => {
                this.validate();
                if (this.scope.validationMessages.length == 0) {
                    this.dismissModal(true);
                }
            }

            workflowService.getOutputOrder(model.workflowBlock.id).then(
                (dto) => {
                    this.scope.model.dto = dto;
                });
            
        }

        private validate() {
            this.scope.validationMessages = [];
            if (this.scope.model && this.scope.model.dto && this.scope.model.dto.toBlocks) {
                if (Enumerable.from(this.scope.model.dto.toBlocks).any(i => i.order === undefined || i.order === null)) {
                    this.scope.validationMessages.push("All destination workflow blocks must be given an output order")
                }
                var orderedToBlocks = Enumerable.from(this.scope.model.dto.toBlocks).orderBy(i => i.order).toArray();
                for (var i = 0; i < orderedToBlocks.length; i++) {
                    if (orderedToBlocks[i].order !== i) {
                        this.scope.validationMessages.push("The destination workflow block must be sequential and begin with zero");
                        break;
                    }
                }
            }
        }
    }
}

warsApp.registerController('OutputOrderSettingsModalController', ['$scope', 'model', 'workflowService', 'close']);